module.exports = __webpack_public_path__ + "static/media/StrenthenImpact.65810953.png";